﻿import * as React from 'react';
import { NavLink } from "react-router-dom";

export default function SettingsLauncher() {

    return (
        <div id="assets-launcher-container">
            <h1 className="main-title">SETTINGS LAUNCHER</h1>

            <div className="card-container">
                <NavLink className="pw-card-link" to="/benchsheet-settings">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon pw-pink">dynamic_form</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title pw-pink">Bench Sheets</div>
                        </div>
                    </div>
                </NavLink>


            </div>
        </div>
    );
}


